import { croodles } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import SubtleBadge from 'components/common/SubtleBadge';
import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PlayerWidget = ({
  type = 'complete',
  name,
  score = null,
  price,
  deleted,
  code = null,
  playerType = null
}) => {
  const url = `/${playerType == 'S' ? 'students' : 'teachers'}/${code}`;
  const avatar = createAvatar(croodles, {
    seed: name,
    ...(deleted && {
      topColor: ['748194'],
      mouth: ['variant18'],
      eyes: ['variant12']
    })
  }).toDataUriSync();
  return (
    <div className="p-3 h-100">
      <div className="avatar avatar-4xl mb-2">
        <Image roundedCircle src={avatar} className="mb-2" />
        {deleted ? (
          <SubtleBadge
            pill
            bg="secondary"
            className="fs-10 position-absolute top-100 translate-middle"
          >
            Eliminato
          </SubtleBadge>
        ) : (
          <SubtleBadge
            pill
            bg={
              type === 'complete' || type === 'score'
                ? score >= 0
                  ? 'success'
                  : 'danger'
                : 'success'
            }
            className="fs-10 position-absolute top-100 translate-middle"
          >
            {type === 'complete' || type === 'score'
              ? 'Punti: ' + score
              : 'Prezzo: ' + price}
          </SubtleBadge>
        )}
      </div>
      <h5 className="mt-2 mb-1">
        {deleted ? (
          <span className="text-secondary">{name}</span>
        ) : (
          <Link to={code ? url : '#'}>{name}</Link>
        )}
      </h5>
      {type === 'complete' && (
        <h6 className="mb-1 text-700">
          <strong>Prezzo: </strong>
          {price}
        </h6>
      )}
    </div>
  );
};

PlayerWidget.propTypes = {
  type: PropTypes.oneOf(['complete', 'price', 'score']),
  name: PropTypes.string,
  score: PropTypes.number,
  price: PropTypes.number,
  deleted: PropTypes.bool,
  code: PropTypes.string,
  playerType: PropTypes.oneOf(['S', 'T'])
};

export default PlayerWidget;
